import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      <style>{`
        .about-home {
          padding: 85px 0;
        }

        .about-card {
          background: #ffffff;
          padding: 38px;
          border-radius: 20px;
          box-shadow: 0 10px 35px rgba(0,0,0,0.08);
          border: 1px solid rgba(0,0,0,0.05);
          animation: fadeUp 0.9s ease;
        }

        .about-img {
          width: 100%;
          border-radius: 20px;
          box-shadow: 0px 12px 30px rgba(0,0,0,0.15);
        }

        .about-title {
          font-size: 32px;
          font-weight: 800;
          margin-bottom: 15px;
        }

        .about-text {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
        }

        .about-highlights li {
          margin-bottom: 8px;
          font-size: 15px;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <section className="about-home">
        <div className="container">
          <div className="row align-items-center g-4">

            {/* LEFT IMAGE */}
            <div className="col-lg-6">
              <img 
                src="/about-img.jpg" 
                className="about-img" 
                alt="About SWIFTSHIP" 
              />
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-6">
              <div className="about-card">
                
                <h2 className="about-title">Your Trusted U.S. Logistics Partner</h2>

                <p className="about-text">
                  SWIFTSHIP delivers fast, secure and technology-driven logistics solutions 
                  for businesses and individuals across the United States. 
                  Operating as an Arizona-registered company, we bring full transparency, reliability, 
                  and professional service standards to every shipment—domestic or international.
                </p>

                <ul className="about-highlights">
                  <li>✔ Professional domestic & global shipping network</li>
                  <li>✔ Real-time tracking with dedicated support</li>
                  <li>✔ Secure warehousing & fulfillment for businesses</li>
                  <li>✔ Transparent pricing with no hidden charges</li>
                </ul>

                <Link to="/about">
                  <button className="btn btn-primary mt-4 px-4">Learn More →</button>
                </Link>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
